import { Grid } from '@material-ui/core';
import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import TitleTypography from '../TitleTypography';
import DisplayPrice from '../../DisplayPrice';
import DoubleArrowIcon from '../Icons/DoubleArrowIcon';

import useStyles from './makeStyles';

const StepNavigationAmount = ({ amount, isMobile, iconDown, isFetchingPrice }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Grid item xs={7} md={8}>
        <Typography className={classes.paymentTotal}>
          {t('paymentTotal')}
          :
        </Typography>
      </Grid>
      <Grid item xs={5} md={4}>
        <Grid container justifyContent="flex-end" alignItems="center" spacing={1} className={classes.amountBox}>
          <Grid item>
            <TitleTypography component="div" className={classes.price}>
              <DisplayPrice price={amount} isFetching={isFetchingPrice} />
            </TitleTypography>
          </Grid>
          {
            isMobile && (
              <Grid item className={classes.arrowIcon}>
                <DoubleArrowIcon down={iconDown} />
              </Grid>
            )
          }
        </Grid>
      </Grid>
    </>
  );
};

StepNavigationAmount.propTypes = {
  amount: PropTypes.number,
  isMobile: PropTypes.bool.isRequired,
  iconDown: PropTypes.bool.isRequired,
  isFetchingPrice: PropTypes.bool,
};

StepNavigationAmount.defaultProps = {
  amount: 0,
  isFetchingPrice: false,
};

export default StepNavigationAmount;
